import { useMemo } from 'react'

import { useFilters } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'
import type { PageContextPayload } from '@contexts/pageContext'

import PageContent from './components/PageContent'

const Quotes = () => {
  const filterPayload = useFilters({
    persistFilters: true,
    persistedExternalFilterKeys: ['status'],
  })

  const {
    callbacks: filterCallbacks,
    defaultFilters,
  } = filterPayload

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <PageContent filterPayload={filterPayload} />
    </PageContext.Provider>
  )
}

export default Quotes
